import * as React from "react";
import { TextInput } from "../text-input";
import { TextInputProps } from "../text-input/types";

import "./styles.scss";

export default function SearchInput(props: TextInputProps): React.JSX.Element {
  return (
    <TextInput
      {...props}
      type="search"
      endAdornment={<i className="icon-scd-search" />}
    />
  );
}
